module.exports = __webpack_public_path__ + "img/gandup.875603ed.png";